import { useEffect, useState } from 'react'
import { Navigate } from 'react-router-dom'
import { fetchAuth0LogoutUrl, useAuth } from 'grabbitbot-legacy-ui'
import { apiClient } from '../../api/client'

// Equivalent of legacy `UserLogoutComponent` (audit §3a). Owner decision
// 2026-09-26 (legacy-migration/RULES.md): logout now ALSO ends the Auth0
// tenant session (`GET /user/logout/auth0`), not just the local token —
// otherwise a live Auth0 session could silently sign the user straight back
// in on the next "Log in" click. `logout()` clears the local token and the
// in-SPA auth state synchronously (unchanged from legacy); the Auth0 round
// trip is a best-effort ADDITION — if it fails (Auth0 not configured,
// network error, backend not deployed yet — see README "Known gaps"), the
// user falls back to the in-app `/login` page instead of being stranded.
export function LogoutPage() {
  const { logout } = useAuth()
  const [fallback, setFallback] = useState(false)

  useEffect(() => {
    logout()
    let cancelled = false
    fetchAuth0LogoutUrl(apiClient)
      .then((logoutUrl) => {
        if (!cancelled) window.location.assign(logoutUrl)
      })
      .catch(() => {
        if (!cancelled) setFallback(true)
      })
    return () => {
      cancelled = true
    }
    // Runs once on mount only.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (fallback) return <Navigate to="/login" replace />
  return <p>Signing out…</p>
}
